import { useEffect, useMemo } from 'react';

import { getOperatingSystem } from '../utils';

export function useShortcutKey(keyValue: string, callback: () => void, shouldUseWithCommand = true) {
  // Adds a keyboard shortcut to toggle the sidebar.

  const os = useMemo(() => getOperatingSystem(), []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === keyValue && shouldUseWithCommand && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [keyValue, shouldUseWithCommand, callback]);

  return { os, osKey: os === 'macOS' ? '⌘' : '⌘' };
}
